import React from "react";

// Six digits from an authenticator app, or a recovery code (xxxxx-xxxxx).
const CodeInput = ({ value, onChange, recovery = false, id = "mfaCode" }) => (
  <input
    id={id}
    className={`mfa-code-input ${recovery ? "mfa-recovery" : ""}`}
    value={value}
    autoFocus
    autoComplete="one-time-code"
    inputMode={recovery ? "text" : "numeric"}
    maxLength={recovery ? 20 : 7}
    placeholder={recovery ? "xxxxx-xxxxx" : "000000"}
    aria-label={recovery ? "Recovery code" : "Six-digit code"}
    onChange={(e) =>
      onChange(recovery ? e.target.value.trim() : e.target.value.replace(/\D/g, "").slice(0, 6))
    }
  />
);

export default CodeInput;
